import { useContext } from "react";
import { HttpMethods } from "../../../enums/HttpMethods";
import { NotificationTypes } from "../../../enums/NotificationTypes";
import { VspPortalActions } from "../../../store/VspPortalActions";
import VspPortalContext from "../../../store/VspPortalContext";
import { ScheduleDto } from "../dtos/ScheduleDto";
import { DoorDto } from "../dtos/DoorDto";
import { useVspPortalHttp } from "../../../hooks/useVspPortalHttp";

export const useCommonDoorScheduleHttp = ( ): {

    getDoors( villageCode: string ): Promise< DoorDto[] | null>,
    getSchedule( doorCode: string, villageCode: string): Promise< ScheduleDto | null>,
    submitSchedule( scheduleName: string, villageCode: string, scheduleDto: ScheduleDto ): Promise< boolean >,

} => {

    const { dispatch } = useContext( VspPortalContext );
    const { fetchData, getHttpOptions } = useVspPortalHttp( );
    
    const getDoors = async( villageCode: string ): Promise< DoorDto[] | null > => {

        
        const options = await getHttpOptions ( HttpMethods.Get, undefined );
        const query = `${process.env.REACT_APP_API_URL}/commondoorschedule/doors?villageCode=${villageCode}`;

        const response = await fetchData( options, query  );

        if ( response == null ) {

            dispatch({ type: VspPortalActions.SetNotificationType, payload: NotificationTypes.Error });
            dispatch({ type: VspPortalActions.SetNotificationText, payload: 'Error fetching doors' });

            return null;

        }

        if ( response.statusCode === 200 ) {
        
            const doors = await response.response?.json( );
            
            if( doors == null )
            {
                dispatch({ type: VspPortalActions.SetNotificationType, payload: NotificationTypes.Error });
                dispatch({ type: VspPortalActions.SetNotificationText, payload: 'Error fetching doors' });

                return null;
            }
            
            return doors;

        }

        return [ ];

    }

    const getSchedule = async ( doorCode: string, villageCode: string): Promise< ScheduleDto | null> => {

        
        const options = await getHttpOptions ( HttpMethods.Get, undefined );
        const query = `${process.env.REACT_APP_API_URL}/commondoorschedule/schedule?doorCode=${doorCode}&villageCode=${villageCode}`;

        const response = await fetchData( options, query  );

        if ( response == null ) {

            dispatch({ type: VspPortalActions.SetNotificationType, payload: NotificationTypes.Error });
            dispatch({ type: VspPortalActions.SetNotificationText, payload: 'Error fetching doors' });

            return null;

        }

        if ( response.statusCode === 200 ) {
        
            const schedule = await response.response?.json( );
            
            if( schedule == null )
            {
                dispatch({ type: VspPortalActions.SetNotificationType, payload: NotificationTypes.Error });
                dispatch({ type: VspPortalActions.SetNotificationText, payload: 'Error fetching schedule' });

                return null;
            }
            
            return schedule;

        }

        return null;


    };
    
    
    const submitSchedule = async( scheduleCode: string, villageCode: string, scheduleDto: ScheduleDto ) : Promise< boolean > => {
    
        
        const options = await getHttpOptions ( HttpMethods.Post, JSON.stringify( scheduleDto ) );
        const query = `${process.env.REACT_APP_API_URL}/commondoorschedule?villageCode=${villageCode}&scheduleCode=${scheduleCode}`;
        const response = await fetchData( options, query  );

        if ( response == null || response.statusCode !== 204 ) {

            dispatch({ type: VspPortalActions.SetNotificationType, payload: NotificationTypes.Error });
            dispatch({ type: VspPortalActions.SetNotificationText, payload: 'Error submitting common door schedule' });
            return false;

        }

        dispatch({ type: VspPortalActions.SetNotificationType, payload: NotificationTypes.Success });
        dispatch({ type: VspPortalActions.SetNotificationText, payload: 'Common door schedule successfully submitted!' });

        return true;

    };

    return {

        getDoors,
        getSchedule,
        submitSchedule,

    };
};